// import axios from "axios";
// import React, { useState } from "react";
// import { Card, Row, Col, Badge } from "react-bootstrap";
// import ReviewCard from "./ReviewCard";
// import ReactStars from "react-rating-stars-component"; 

// const Reviews = ({ reviews }) => {
//   return (
//     <section
//       className="reviews-section"
//       style={{
//         padding: "50px 20px",
//         backgroundColor: "#f9f9f9",
//         borderRadius: "10px",
//         boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
//       }}
//     >
//       <h2 className="text-center mb-4" style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
//         What Our Students Are Saying
//       </h2>
//       <Row>
//         {reviews.map((review, index) => (
//           <Col key={index} md={6} lg={4} className="mb-4">
//             <Card
//               className="review-card"
//               style={{
//                 borderRadius: "10px",
//                 boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
//                 transition: "transform 0.3s ease-in-out",
//               }}
//             >
//               <Card.Body
//                 className="p-4"
//                 style={{
//                   backgroundColor: "#fff",
//                   borderRadius: "10px",
//                   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//                 }}
//               >
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <div>
//                     <h5
//                       className="user-name mb-0"
//                       style={{
//                         fontSize: "1.2rem",
//                         fontWeight: "bold",
//                         color: "#333",
//                       }}
//                     >
//                       {review.user}
//                     </h5>
//                     <span
//                       className="text-muted"
//                       style={{
//                         fontSize: "0.9rem",
//                         color: "#aaa",
//                       }}
//                     >
//                       2 days ago
//                     </span>
//                   </div>
//                   <div>
//                     <ReactStars
//                       count={5}
//                       value={review.rating}
//                       size={24}
//                       activeColor="#ffd700"
//                       isHalf={true}
//                       edit={false}
//                     />
//                   </div>
//                 </div>
//                 <Card.Text
//                   className="review-text"
//                   style={{
//                     fontSize: "1rem",
//                     color: "#555",
//                     lineHeight: "1.5",
//                     height: "100px",
//                     overflow: "hidden",
//                   }}
//                 >
//                   {review.review}
//                 </Card.Text>
//                 <div className="d-flex justify-content-end mt-3">
//                   <Badge
//                     pill
//                     bg="secondary"
//                     style={{
//                       fontSize: "0.9rem",
//                       fontWeight: "bold",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Read more
//                   </Badge>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>
//     </section>
//   );
// };

// export default Reviews;

// import axios from "axios";
// import React from "react";
// import { Card, Row, Col, Badge,Spinner } from "react-bootstrap";
// import ReactStars from "react-rating-stars-component";
// import { formatDistanceToNow } from "date-fns"; 




// const Reviews = ({ reviews, loading }) => {
//   return (
//     <section
//       className="reviews-section"
//       style={{
//         padding: "50px 20px",
//         backgroundColor: "#f9f9f9",
//         borderRadius: "10px",
//         boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
//         minHeight: "300px",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: loading ? "center" : "flex-start",
//         alignItems: "center",
//       }}
//     >
//       <h2 className="text-center mb-4" style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
//         What Our Students Are Saying
//       </h2>

//       {loading ? (
//         <Spinner animation="border" role="status" style={{ width: "3rem", height: "3rem" }}>
//           <span className="visually-hidden">Loading...</span>
//         </Spinner>
//       ) : (
//         <Row className="justify-content-center w-100">
//           {reviews.length === 0 ? (
//             <p></p>
//           ) : (
//             reviews.map((review, index) => (
//               <Col key={index} md={6} lg={4} className="mb-4 d-flex">
//                 <Card
//                   className="review-card"
//                   style={{
//                     borderRadius: "10px",
//                     boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
//                     transition: "transform 0.3s ease-in-out",
//                     width: "100%",
//                     minHeight: "250px",
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <Card.Body
//                     className="p-4 d-flex flex-column"
//                     style={{
//                       backgroundColor: "#fff",
//                       borderRadius: "10px",
//                       boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//                       flexGrow: 1,
//                     }}
//                   >
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                       <div>
//                         <h5
//                           className="user-name mb-0"
//                           style={{
//                             fontSize: "1.2rem",
//                             fontWeight: "bold",
//                             color: "#333",
//                           }}
//                         >
//                           {review.user}
//                         </h5>
//                         <span
//                           className="text-muted"
//                           style={{
//                             fontSize: "0.9rem",
//                             color: "#aaa",
//                           }}
//                         >
//                           {formatDistanceToNow(new Date(review.created_at), { addSuffix: true })}
//                         </span>
//                       </div>
//                       <div>
//                         <ReactStars
//                           count={5}
//                           value={review.rating}
//                           size={24}
//                           activeColor="#ffd700"
//                           isHalf={true}
//                           edit={false}
//                         />
//                       </div>
//                     </div>
//                     <Card.Text
//                       className="review-text flex-grow-1"
//                       style={{
//                         fontSize: "1rem",
//                         color: "#555",
//                         lineHeight: "1.5",
//                         minHeight: "80px",
//                         maxHeight: "120px",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {review.review}
//                     </Card.Text>
//                     <div className="d-flex justify-content-end mt-3">
//                       <Badge
//                         pill
//                         bg="secondary"
//                         style={{
//                           fontSize: "0.9rem",
//                           fontWeight: "bold",
//                           cursor: "pointer",
//                         }}
//                       >
//                         Read more
//                       </Badge>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             ))
//           )}
//         </Row>
//       )}
//     </section>
//   );
// };

// export default Reviews;
import React, { useState } from "react";
import { Card, Row, Col, Badge, Container } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import { formatDistanceToNow } from "date-fns";
// import "./Reviews.css"; // We'll include the CSS inline at the bottom

const ReviewSkeleton = () => {
  return (
    <Col md={6} lg={4} className="mb-4 d-flex">
      <Card className="review-card skeleton-card">
        <Card.Body className="p-4 d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <div className="skeleton-line skeleton-name"></div>
              <div className="skeleton-line skeleton-date"></div>
            </div>
            <div className="skeleton-stars"></div>
          </div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text" style={{ width: "70%" }}></div>
          <div className="d-flex justify-content-end mt-3">
            <div className="skeleton-badge"></div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

const Reviews = ({ reviews = [], loading = false }) => {
  const [expandedReviews, setExpandedReviews] = useState({});

  const toggleReadMore = (index) => {
    setExpandedReviews({
      ...expandedReviews,
      [index]: !expandedReviews[index],
    });
  };

  // Generate skeleton cards when loading
  const skeletonCards = Array(6)
    .fill(0)
    .map((_, index) => <ReviewSkeleton key={`skeleton-${index}`} />);

  return (
    <section className="reviews-section text-center">
      <Container>
        <h2 className="section-title text-center mb-5">
          What Our Students Are Saying
        </h2>

        {loading ? (
          <Row className="justify-content-center w-100 fade-in">
            {skeletonCards}
          </Row>
        ) : (
          <Row className="justify-content-center w-100">
            {reviews.length === 0 ? (
              <p className="text-center">No reviews yet. Be the first to leave one!</p>
            ) : (
              reviews.map((review, index) => (
                <Col key={index} md={6} lg={4} className="mb-4 d-flex review-col fade-in">
                  <Card className="review-card">
                    <div className="card-gradient-border">
                      <Card.Body className="p-4 d-flex flex-column">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h5 className="user-name mb-0">{review.user}</h5>
                            <span className="review-date">
                              {formatDistanceToNow(new Date(review.created_at), { addSuffix: true })}
                            </span>
                          </div>
                          <div className="rating-container">
                            <ReactStars
                              count={5}
                              value={review.rating}
                              size={24}
                              activeColor="#ff6b9d"
                              isHalf={true}
                              edit={false}
                            />
                          </div>
                        </div>
                        <Card.Text className={`review-text ${expandedReviews[index] ? "expanded" : ""}`}>
                          {review.review}
                        </Card.Text>
                        <div className="d-flex justify-content-end mt-3">
                          <Badge
                            pill
                            className="read-more-badge"
                            onClick={() => toggleReadMore(index)}
                          >
                            {expandedReviews[index] ? "Show less" : "Read more"}
                          </Badge>
                        </div>
                      </Card.Body>
                    </div>
                  </Card>
                </Col>
              ))
            )}
          </Row>
        )}
      </Container>

      <style jsx>{`
        /* CSS styles for the Reviews component */
        .reviews-section {
          padding: 60px 20px;
          background: linear-gradient(135deg, #f5f7ff 0%, #f9f2ff 100%);
          border-radius: 10px;
          min-height: 300px;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: bold;
          background: linear-gradient(90deg, #6e72fc 0%, #ff758c 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1.5rem;
          position: relative;
          display: inline-block;
        }

        .section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #6e72fc 0%, #ff758c 100%);
          border-radius: 2px;
        }

        .review-col {
          transition: transform 0.4s ease-in-out;
        }

        .review-col:hover {
          transform: translateY(-10px);
        }

        .review-card {
          border-radius: 16px;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease-in-out;
          width: 100%;
          min-height: 250px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          overflow: hidden;
          border: none;
        }

        .card-gradient-border {
          position: relative;
          border-radius: 16px;
          background: white;
          padding: 1px;
          overflow: hidden;
        }

        .card-gradient-border::before {
          content: '';
          position: absolute;
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: linear-gradient(45deg, #6e72fc, #ad1deb, #ff758c, #ff7eb3);
          z-index: -1;
          border-radius: 16px;
          animation: animatedgradient 3s ease alternate infinite;
          background-size: 300% 300%;
        }

        @keyframes animatedgradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        .review-card:hover {
          box-shadow: 0 15px 30px rgba(110, 114, 252, 0.2);
        }

        .user-name {
          font-size: 1.2rem;
          font-weight: bold;
          color: #333;
          transition: color 0.3s ease;
        }

        .review-card:hover .user-name {
          color: #6e72fc;
        }

        .review-date {
          font-size: 0.9rem;
          color: #aaa;
        }

        .review-text {
          font-size: 1rem;
          color: #555;
          line-height: 1.6;
          max-height: 80px;
          overflow: hidden;
          transition: max-height 0.5s ease;
          position: relative;
        }

        .review-text.expanded {
          max-height: 1000px;
        }

        .review-text:not(.expanded)::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 30px;
          background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
        }

        .read-more-badge {
          background: linear-gradient(90deg, #6e72fc 0%, #ff758c 100%);
          border: none;
          padding: 8px 15px;
          font-size: 0.9rem;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 10px rgba(110, 114, 252, 0.3);
        }

        .read-more-badge:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 15px rgba(110, 114, 252, 0.4);
        }

        .rating-container {
          background: rgba(255, 255, 255, 0.8);
          padding: 3px 8px;
          border-radius: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        /* Skeleton styles */
        .skeleton-card {
          background: white;
        }

        .skeleton-line {
          background: linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          height: 12px;
          margin-bottom: 8px;
        }

        .skeleton-name {
          width: 120px;
          height: 18px;
        }

        .skeleton-date {
          width: 80px;
          height: 12px;
        }

        .skeleton-stars {
          width: 120px;
          height: 24px;
          background: linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-text {
          width: 100%;
          height: 12px;
          margin-bottom: 10px;
          background: linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-badge {
          width: 80px;
          height: 30px;
          border-radius: 20px;
          background: linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        /* Animation for fade-in */
        .fade-in {
          animation: fadeIn 0.8s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Reviews;